import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type EventType = {
  id: number;
  uuid: string;
  slug: string;
  template_id: string;
  created_at?: string | null;
};

interface UtilState {
  event: EventType;
  setEvent: (event: Partial<EventType>) => void;
  hasDashboardLoaded: boolean; // New state
  setHasDashboardLoaded: (loaded: boolean) => void; // New setter
  sidebarLayout: "list" | "grid";
  setSidebarLayout: (layout: "list" | "grid") => void;
}

export const useAppStore = create<UtilState>()(
  persist(
    (set) => ({
      event: {
        id: 0,
        uuid: "",
        slug: "",
        template_id: "",
      },
      setEvent: (event) =>
        set((state) => ({
          ...state,
          event: {
            ...state.event,
            ...event,
          },
        })),
      hasDashboardLoaded: false,
      setHasDashboardLoaded: (loaded) => set({ hasDashboardLoaded: loaded }),
      sidebarLayout: "grid",
      setSidebarLayout: (layout) => set({ sidebarLayout: layout }),
    }),
    {
      name: "event-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useAppStore;
